import { render, staticRenderFns } from "./resetMpinComponent.vue?vue&type=template&id=c0d4cb72&"
import script from "./resetMpinComponent.vue?vue&type=script&lang=js&"
export * from "./resetMpinComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports